import {
  AUTOPANELS_DATA_TYPES_BLACKLIST,
  IVirtualManifestBuilderProps,
  IntersectionVirtualManifestBuilder,
  ManifestPropertyFilter,
  ReducibleKey,
} from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { BaseActionPanelAPI } from './BaseActionPanelAPI';
import { EditorPointer } from '@wix/editor-document-logic-api';

export class SettingsActionPanelAPI extends BaseActionPanelAPI {
  constructor(readonly editorPointers: EditorPointer<CompRef>[]) {
    super();
  }

  getContent() {
    return undefined;
  }

  async getHostContext(props?: IVirtualManifestBuilderProps) {
    const filter: ManifestPropertyFilter = (
      manifestProp: ReducibleKey,
      _key: string,
      definition: any,
    ) => {
      return (
        (manifestProp === 'data' || manifestProp === 'states') &&
        !AUTOPANELS_DATA_TYPES_BLACKLIST.includes(definition?.dataType)
      );
    };

    return this.getInfraSDKHostContext({
      ...props,
      editorPointers: props?.editorPointers || this.editorPointers,
      contextBuilder: (builder) =>
        builder.extend(IntersectionVirtualManifestBuilder).withFilters(filter),
    });
  }
}
